export function BrandLockup({ compact = false }) {
  return (
    <a className="du-brand" href="/" aria-label="DenkUP ana sayfa">
      <span className="du-brand__mark">
        <span className="du-brand__aura" />
        <span className="du-brand__sweep" />
        <img src="/brand/newlogo_1.png" alt="DenkUP logo" />
      </span>
      {!compact ? (
        <span className="du-brand__copy">
          <strong>DENKUP</strong>
          <small>Events / Squads</small>
        </span>
      ) : null}
    </a>
  );
}

export function Button({ children, variant = "primary", size = "md", className = "", ...props }) {
  return (
    <button className={`du-button du-button--${variant} du-button--${size} ${className}`.trim()} type="button" {...props}>
      {children}
    </button>
  );
}

export function Pill({ children, tone = "cyan", className = "" }) {
  return (
    <span className={`du-pill du-pill--${tone} ${className}`.trim()}>
      {children}
    </span>
  );
}

export function GlassCard({ children, tone = "cyan", className = "", as: Element = "article", ...props }) {
  return (
    <Element className={`du-card du-card--${tone} ${className}`.trim()} {...props}>
      {children}
    </Element>
  );
}

export function SectionHeader({ eyebrow, title, description, align = "left" }) {
  return (
    <div className={`section-header section-header--${align}`}>
      {eyebrow ? <Pill tone="green">{eyebrow}</Pill> : null}
      <h2>{title}</h2>
      {description ? <p>{description}</p> : null}
    </div>
  );
}

export function IconBadge({ label, tone = "cyan" }) {
  return <span className={`du-icon-badge du-icon-badge--${tone}`}>{label}</span>;
}

export function MetricCard({ value, label, tone = "cyan" }) {
  return (
    <GlassCard tone={tone} className="metric-card">
      <strong>{value}</strong>
      <span>{label}</span>
    </GlassCard>
  );
}

export function FeatureCard({ icon, title, description, tone = "cyan" }) {
  return (
    <GlassCard tone={tone} className="feature-card">
      <IconBadge label={icon} tone={tone} />
      <h3>{title}</h3>
      <p>{description}</p>
    </GlassCard>
  );
}
